import type { ReactNode } from 'react'
import { type Report, useSuspenseDecrypt } from '../hooks'
import type { Attachment } from './FormItemsAnswers'
import { VoiceMessagePlayer } from './VoiceMessagePlayer'

type MoreInformationContentProps = {
  report: Report
  attachments: Attachment[]
  encryptionKey: string
  renderRow?: (content: ReactNode) => ReactNode
}

export const MoreInformationContent = ({
  report,
  attachments,
  encryptionKey,
  renderRow,
}: MoreInformationContentProps) => {
  const { moreInfo } = useSuspenseDecrypt(report)

  if (!moreInfo && attachments.length === 0) {
    return null
  }

  const content = (
    <>
      {moreInfo}
      {attachments.length > 0 && (
        <div className='mt-1 flex flex-col gap-2'>
          {attachments.map(attachment => (
            <VoiceMessagePlayer
              key={attachment.id}
              attachment={attachment}
              encryptionKey={encryptionKey}
              label={attachment.name}
            />
          ))}
        </div>
      )}
    </>
  )

  return renderRow ? renderRow(content) : content
}
